angular
  .module('surfsightApp.controllers')
  .controller('surfMp4PlayerWithAccelerometerController', [
    '$scope',
    'SystemConstants',
    function ($scope, SystemConstants) {
      const totalTime = 10
      $scope.accelerometerDataState = {
        show: true,
        sliderValue: 0,
        data: $scope.accelerometerData.map((d, index, intialValue) => ({
          ...d,
          speed: d.speedInKmph * (SystemConstants.unit === 1 ? 0.621371 : 1),
          time: (d.time - intialValue[0].time) / 1000 - totalTime / 2
        })),
        selectedData: {
          speed: 0,
          x: 0,
          y: 0
        }
      }
      $scope.videoMetadata = {}
      const timeScale = [-5, 5]
      $scope.onVideoMetadataUpdate = d => {
        $scope.videoMetadata = d
        $scope.accelerometerDataState.sliderValue =
          $scope.videoMetadata.sliderValue
        setReferenceValue()
        setSelectedData()
      }
      const updateProgressBarStaus = () => {
        const newCurrentTime =
          $scope.videoMetadata.duration *
          ($scope.accelerometerDataState.sliderValue / 100)
        setReferenceValue(true)
        setSelectedData()
        $scope.$broadcast('surfMp4Player.updateCurrentTime', {
          currentTime: newCurrentTime
        })
      }
      const setReferenceValue = (useSliderValue = false) => {
        const referenceValuePercentage = useSliderValue
          ? $scope.accelerometerDataState.sliderValue / 100
          : $scope.videoMetadata.currentTime / $scope.videoMetadata.duration
        const referenceValue =
          timeScale[0] +
          referenceValuePercentage * (timeScale[1] - timeScale[0])
        $scope.accelerometerDataState.referenceValue = referenceValue
      }
      const setSelectedData = () => {
        const { referenceValue } = $scope.accelerometerDataState
        const { selectedData } = $scope.accelerometerDataState.data.reduce(
          (acc, item) =>
            acc.difference < Math.abs(item.time - referenceValue)
              ? acc
              : {
                  selectedData: {
                    ...item
                  },
                  difference: Math.abs(item.time - referenceValue)
                },
          {
            selectedData: null,
            difference: Infinity
          }
        )
        $scope.accelerometerDataState.selectedData = selectedData
      }
      $scope.onSliderValueChange = () => {
        updateProgressBarStaus()
      }
      $scope.onMdDrag = e => {
        $scope.onSliderValueChange()
        $scope.$apply()
      }
    }
  ])
